import React from 'react';
import { ArrowRight } from 'lucide-react';

// Option D: Magazine Editorial
const OptionD = () => {
  const scrollToPricing = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      {/* Editorial Hero Section */}
      <section style={{ padding: '60px 40px 100px', maxWidth: '1600px', margin: '0 auto', position: 'relative' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'center' }}>
          
          {/* Left Column - Image (Larger) */}
          <div style={{ position: 'relative' }}>
            <div
              style={{
                width: '100%',
                height: '700px',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
              }}
            >
              <img
                src="https://customer-assets.emergentagent.com/job_clean-typography-1/artifacts/sr5hx03f_pexels-alex-green-5691834.jpg"
                alt="Happy children"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center 30%',
                }}
              />
            </div>
            
            {/* Floating badge */}
            <div
              style={{
                position: 'absolute',
                bottom: '-30px',
                right: '40px',
                background: '#E85D35',
                color: 'white',
                padding: '32px 40px',
                borderRadius: '12px',
                boxShadow: '0 12px 40px rgba(232, 93, 53, 0.3)',
              }}
            >
              <div style={{ fontSize: '0.75rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '8px' }}>
                Just
              </div>
              <div style={{ fontSize: '3rem', fontWeight: '900', lineHeight: '1' }}>
                RM4.99
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div style={{ paddingLeft: '40px' }}>
            <div
              style={{
                fontSize: '0.9rem',
                fontWeight: '600',
                color: '#E85D35',
                textTransform: 'uppercase',
                letterSpacing: '0.15em',
                marginBottom: '24px',
              }}
            >
              Switch Schools Diagnostic
            </div>
            
            <h1
              style={{
                fontSize: 'clamp(2.5rem, 4vw, 4rem)',
                fontWeight: '900',
                lineHeight: '1.05',
                color: '#2C2823',
                marginBottom: '32px',
                fontFamily: "'PP Right Grotesk', 'Inter', Arial, sans-serif",
                textTransform: 'uppercase',
              }}
            >
              CONFIDENT SCHOOL DECISIONS, BUILT AROUND YOUR CHILD.
            </h1>

            <div
              style={{
                borderLeft: '4px solid #E85D35',
                paddingLeft: '24px',
                marginBottom: '40px',
              }}
            >
              <p
                style={{
                  fontSize: '1.35rem',
                  lineHeight: '1.6',
                  color: '#6B6560',
                }}
              >
                A 15-minute diagnostic that cuts through the noise — fee projections, tuition data, and honest school comparisons, all in one report.
              </p>
            </div>

            <button
              onClick={scrollToPricing}
              style={{
                background: '#E85D35',
                color: 'white',
                border: 'none',
                borderRadius: '10rem',
                padding: '1.2em 2.5em',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.3s ease',
                textTransform: 'uppercase',
                marginBottom: '48px',
              }}
              onMouseOver={(e) => (e.target.style.transform = 'scale(1.02)')}
              onMouseOut={(e) => (e.target.style.transform = 'scale(1)')}
            >
              See How It Works
              <ArrowRight size={20} />
            </button>

            {/* Stats Row */}
            <div style={{ display: 'flex', gap: '48px', flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontSize: '2.5rem', fontWeight: '900', color: '#E85D35', lineHeight: '1' }}>500+</div>
                <div style={{ fontSize: '0.85rem', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: '8px' }}>
                  Parents Served
                </div>
              </div>
              <div>
                <div style={{ fontSize: '2.5rem', fontWeight: '900', color: '#E85D35', lineHeight: '1' }}>45+</div>
                <div style={{ fontSize: '0.85rem', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: '8px' }}>
                  Schools
                </div>
              </div>
              <div>
                <div style={{ fontSize: '2.5rem', fontWeight: '900', color: '#E85D35', lineHeight: '1' }}>94%</div>
                <div style={{ fontSize: '0.85rem', color: '#6B6560', textTransform: 'uppercase', letterSpacing: '0.1em', marginTop: '8px' }}>
                  Satisfaction
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Large Background Text */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: 'clamp(8rem, 15vw, 18rem)',
            fontWeight: '900',
            color: 'rgba(232, 93, 53, 0.03)',
            zIndex: '0',
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
            fontFamily: "'PP Right Grotesk', 'Inter', Arial, sans-serif",
          }}
        >
          SWITCH
        </div>
      </section>

      {/* Preview Label */}
      <section style={{ padding: '80px 40px', textAlign: 'center', background: 'var(--bg-card)' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '900', color: '#2C2823', marginBottom: '16px' }}>
          OPTION D: MAGAZINE EDITORIAL LAYOUT
        </h2>
        <p style={{ fontSize: '1.1rem', color: '#6B6560', maxWidth: '600px', margin: '0 auto' }}>
          Asymmetric, dynamic, editorial style. Eye-catching with strong visual hierarchy.
        </p>
      </section>
    </div>
  );
};

export default OptionD;
